<template>
  <div id="ecommerce-checkout">
    <div class="my-4">
      <img :src="`/assets/images/logo/logo_basket_${appFilename}.svg`" alt="" height="40px" />
    </div>

    <OrderDetails :orderDetails="orderDetails" />
    <form-wizard
      ref="checkoutWizard"
      color="rgba(var(--vs-primary), 1)"
      :startIndex="0"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
      v-if="!orderId || !orderNumber"
    >
      <tab-content icon="feather icon-user" class="mb-5">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex flex-col md:flex-row p-4 md:p-0" v-if="!basket.email">
                <div class="vx-col  md:mb-0 md:w-2/5">
                  <div class="text-center text-lg bold font-bold">Quero criar uma conta</div>
                  <form @submit.prevent="signup">
                    <vs-input
                      v-validate="'required|email|min:3'"
                      data-vv-validate-on="blur"
                      name="emailNewAccount"
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="E-mail"
                      v-model.trim="emailNewAccount"
                      autocomplete="username"
                      class="w-full no-icon-border"
                    />

                    <vs-input
                      data-vv-validate-on="blur"
                      data-vv-as="Senha"
                      v-validate="'required|min:6|max:30'"
                      type="password"
                      name="passwordNewAccount"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Senha"
                      v-model="passwordNewAccount"
                      autocomplete="new-password"
                      class="w-full no-icon-border mt-6"
                    />

                    <vs-input
                      data-vv-validate-on="blur"
                      data-vv-as="Confirmação da Senha"
                      v-validate="'required|confirmed:passwordNewAccount|min:6|max:30'"
                      type="password"
                      name="passwordConfirmationNewAccount"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Confirmação da Senha"
                      v-model="passwordConfirmationNewAccount"
                      autocomplete="new-password"
                      class="w-full no-icon-border mt-6"
                    />

                    <span
                      class="text-danger text-sm"
                      v-show="
                        passwordConfirmationNewAccount.length &&
                          passwordNewAccount.length &&
                          passwordConfirmationNewAccount !== passwordNewAccount
                      "
                      >A senha e a confirmação da senha devem ser iguais.</span
                    >
                    <div class="flex flex-wrap my-5">
                      <vs-checkbox v-model="termsConfirmation" class="mb-3">Confirmo ter lido e aceito os</vs-checkbox>
                      <a
                        href="https://www.wtsoftware.com.br/suporte/termos-uso.html"
                        style="margin-right: 5px;"
                        target="_blank"
                        >Termos de Uso</a
                      >
                      |
                      <a
                        href="https://www.wtsoftware.com.br/suporte/politica-privacidade.html"
                        style="margin-left: 5px;"
                        target="_blank"
                      >
                        Política de Privacidade</a
                      >
                    </div>

                    <vs-button
                      type="relief"
                      button="button"
                      class="w-full mt-6"
                      @click.prevent="signup()"
                      :disabled="
                        basket.processing || !termsConfirmation || passwordConfirmationNewAccount !== passwordNewAccount
                      "
                    >
                      Continuar
                    </vs-button>
                  </form>
                </div>
                <div class="vx-col hidden md:w-1/5 md:flex justify-center">
                  <div class="bg-grey t w-px h-full">&nbsp;</div>
                </div>
                <div class="vx-col mt-8 md:mt-0 md:w-2/5">
                  <div class="text-center text-lg bold font-bold">Já sou cliente</div>

                  <vs-button type="relief" class="w-full mt-6" @click="login()" :disabled="basket.processing"
                    >Ir para a Página de Login</vs-button
                  >
                </div>
              </div>
              <div v-else class="flex flex-col md:flex-row p-4 md:p-0">
                <div class="vx-col mb-8 md:mb-0 w-full">
                  <div class="text-center text-lg bold font-bold">Você já está logado como {{ basket.email }}</div>

                  <div class="flex flex-col md:flex-row p-4 md:p-0">
                    <div class="md:w-2/5">
                      <vs-button
                        type="relief"
                        color="danger"
                        class="w-full mt-6"
                        @click="logout()"
                        :disabled="basket.processing"
                      >
                        Sair da Conta
                      </vs-button>
                    </div>
                    <div class="md:w-1/5">&nbsp;</div>
                    <div class="md:w-2/5">
                      <vs-button type="relief" class="w-full mt-6" @click="login()" :disabled="basket.processing">
                        Continuar
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </tab-content>

      <tab-content icon="feather icon-shopping-bag" class="mb-5">
        <!-- IF CART HAVE ITEMS -->
        <!-- AQUI VAI ESTAR OS PLANOS -->
        <div class="vx-row" v-if="plans.length">
          <div class="vx-col w-full">
            <!-- plano grátis -->
            <!-- <div
              class="items-list-view rounded-lg bg-white cursor-pointer mb-base"
              @click="changePlanSelected(9999)"
              style="border: 2px solid transparent; box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);"
              :style="planSelected === 9999 ? 'box-shadow: 0 0 4px 2px #713fbc; border: 2px solid #5c3498;' : ''"
            >
              <div class="vx-row item-details no-gutter">
                <div class="vx-col sm:w-3/5">
                  <div class="pt-8 pl-8 md:pb-8">
                    <slot name="item-meta">
                      <h6 class="item-name font-semibold mb-1 hover:text-primary">
                        Plano Grátis
                      </h6>
                    </slot>
                  </div>
                </div>

                <div
                  class="vx-col sm:w-2/5 w-full flex items-center rounded sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
                >
                  <div class="px-4 flex flex-col w-full">
                    <div class="my-6 text-right">
                      <h5>
                        <strong>GRÁTIS</strong>
                      </h5>
                    </div>
                  </div>
                </div>
                <div style="width: 100%;" class="p-6" v-if="9999 === planSelected">
                  <div
                    class="flex lg:flex-row flex-col gap-y-4 p-2 items-start lg:items-start"
                    style="width: 100%; justify-content: space-between;"
                  >
                    <ul>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Áudio do WhatsApp
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Localização
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Chamadas
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        SMS
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Fotos da Galeria
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Contatos
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/eye-off.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Modo invisível
                      </li>
                    </ul>
                    <vs-button
                      type="relief"
                      class="w-full lg:w-2/5"
                      @click="redirectPlan()"
                      :disabled="basket.processing"
                    >
                      Continuar
                    </vs-button>
                  </div>
                </div>
              </div>
            </div> -->
            <div
              class="items-list-view cursor-pointer"
              v-for="item in plans"
              :key="item.id"
              @click="changePlanSelected(item.id)"
            >
              <item-list-view
                :item="item"
                class="mb-base"
                style="border: 2px solid transparent"
                :style="planSelected === item.id ? 'box-shadow: 0 0 4px 2px #713fbc; border: 2px solid #5c3498;' : ''"
              >
                <template v-if="item.id === planSelected" slot="plan-selected">
                  <div
                    class="flex lg:flex-row flex-col gap-y-4 p-2 items-start lg:items-start"
                    style="width: 100%; justify-content: space-between;"
                  >
                    <ul v-if="!item.name.includes('Vip')">
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        WhatsApp
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Chamadas
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Escuta Ambiente
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Localização
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Instagram
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Fotos da Galeria
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        SMS
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/eye-off.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Modo invisível
                      </li>

                      <div>
                        <button
                          @click="toggleExpand"
                          class="btn-expand"
                          style="border: none; display: flex; align-items: center; background-color: transparent; font-size: 16px; font-weight: 600; color: #000; margin-top: 10px; cursor: pointer;"
                        >
                          {{ isExpanded ? 'Esconder todas os recursos' : 'Mostrar todos os recursos' }}
                          <img
                            src="@/assets/images/checkout/chevron-down.svg"
                            alt="check"
                            :class="{ rotated: isExpanded }"
                          />
                        </button>

                        <ul v-if="isExpanded">
                          <li v-for="(funcao, index) in funcoesAdicionais" :key="index" style="font-weight: bold;">
                            <img
                              src="@/assets/images/checkout/check-circle.svg"
                              alt="check"
                              style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                            />
                            {{ funcao }}
                          </li>
                        </ul>
                      </div>
                    </ul>
                    <ul v-else>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Todas as funções premium +
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Zona Segura
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Telegram
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Chamadas do WhatsApp
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/check-circle.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Aplicativos Instalados
                      </li>
                      <li style="font-weight: bold;">
                        <img
                          src="@/assets/images/checkout/eye-off.svg"
                          alt="check"
                          style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                        />
                        Modo invisível
                      </li>
                    </ul>
                    <vs-button
                      type="relief"
                      class="w-full lg:w-2/5"
                      @click="continueCheckoutPlan()"
                      :disabled="basket.processing"
                    >
                      Continuar
                    </vs-button>
                  </div>
                </template>
                <!-- SLOT: ITEM META -->
                <!-- <template slot="item-meta">
                  <h4 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary">{{ item.name }}</h4>

                   <div class="mt-4" v-show="basket.device">
                    <small
                      >{{ $t('PlanWillBeAppliedTo') }}<br /><strong>{{ basket.device }}</strong></small
                    >
                  </div> -->
                <!-- <div v-show="!basket.device && numberOfSubscriptionProducts === 0">
                    <p class="mt-4 font-bold text-sm">Quantidade</p>
                    <vs-input
                      type="number"
                      min="1"
                      max="100"
                      v-model="item.quantity"
                      @input="updateItemQuantity(item)"
                      class="inline-flex"
                      :disabled="basket.processing"
                    />
                  </div>
                </template> -->
                <!-- <h6 class="item-name font-semibold mb-1 hover:text-primary">
                  {{ item.name }}
                </h6>
                <p class="item-description text-sm">{{ item.description }}</p> -->

                <!-- <template slot="action-buttons">
                  <div
                    class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="removePlan(item)"
                    :disabled="basket.processing"
                    v-if="!basket.device"
                  >
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">Remover</span>
                  </div>
                </template> -->
              </item-list-view>
            </div>
          </div>
        </div>
      </tab-content>

      <tab-content icon="feather icon-shopping-cart" class="mb-5">
        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row" v-if="basket.plans.length">
          <div class="vx-col w-full">
            <div class="items-list-view" v-for="item in basket.plans" :key="item.id">
              <item-list-view :item="item" class="mb-base">
                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <h4 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary">{{ item.name }}</h4>

                  <div class="mt-4" v-show="basket.device">
                    <small
                      >{{ $t('PlanWillBeAppliedTo') }}<br /><strong>{{ basket.device }}</strong></small
                    >
                  </div>
                  <div v-show="!basket.device && numberOfSubscriptionProducts === 0">
                    <p class="mt-4 font-bold text-sm">Quantidade</p>
                    <vs-input
                      type="number"
                      min="1"
                      max="100"
                      v-model="item.quantity"
                      @input="updateItemQuantity(item)"
                      class="inline-flex"
                      :disabled="basket.processing"
                    />
                  </div>
                </template>

                <template slot="action-buttons">
                  <div
                    class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="removePlan(item)"
                    :disabled="basket.processing"
                    v-if="!basket.device"
                  >
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">Remover</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>
          <div class="vx-col w-full">
            <vx-card class="mb-6" v-show="showCoupon">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="font-extrabold text-lg font-black w-full flex justify-end mb-6">
                    <vs-input
                      name="coupon"
                      label-placeholder="Código do Cupom"
                      v-model.trim="basket.coupon.code"
                      autocomplete="off"
                      class="w-full no-icon-border"
                    />
                  </div>
                  <div class="w-full text-right mt-6">
                    <vs-button @click="applyCoupon()" type="relief" :disabled="basket.processing">
                      Aplicar Cupom
                    </vs-button>
                  </div>
                </div>
              </div>
            </vx-card>

            <vx-card
              v-if="!basket.device_has_subscription && basket.has_subscription"
              class="bg-danger text-white mb-8 p-6 md:p-0"
            >
              <div class="vx-row">
                <div class="vx-col w-full">
                  <strong>Atenção:</strong> Você já possui 1 ou mais planos VIP ativos. Não compre novamente o plano VIP
                  para o mesmo dispositivo. Em caso de dúvida, entre em contato com nosso suporte.
                  <router-link to="/subscriptions" class="text-white underline"
                    >Clique aqui para ver a lista de planos VIP ativos.
                  </router-link>
                </div>
              </div>
            </vx-card>

            <vx-card v-if="!basket.device_has_subscription" class="mb-16 p-4 md:p-0">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div
                    class="font-extrabold text-lg font-black w-full flex justify-end mb-6"
                    v-if="basket.discount > 0"
                  >
                    <h2>Subtotal: {{ basket.subtotal | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="font-extrabold text-lg w-full flex justify-end mb-6" v-if="basket.discount > 0">
                    <h2 class="text-success">Desconto: -{{ basket.discount | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="font-extrabold text-lg font-black w-full flex justify-end mb-6">
                    <h2>Total: {{ basket.total | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="w-full">
                    <div class="text-sm text-right" v-show="!showCoupon && !numberOfSubscriptionProducts">
                      <a href="javascript:;" @click="showCoupon = !showCoupon">Tenho um cupom</a>
                    </div>
                  </div>
                  <div class="w-full flex mt-6">
                    <vs-button
                      type="relief"
                      color="danger"
                      class="w-1/2 mr-2"
                      @click="$refs.checkoutWizard.prevTab()"
                      :disabled="basket.processing"
                      >{{ $t('GoBack') }}
                    </vs-button>
                    <vs-button
                      type="relief"
                      class="w-1/2 ml-2"
                      @click="$refs.checkoutWizard.nextTab()"
                      :disabled="basket.processing"
                    >
                      {{ $t('Continue') }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </vx-card>

            <vx-card v-else class="bg-danger text-white p-6 md:p-0">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <strong>Atenção:</strong> Este dispositivo já possui o plano VIP ativo. Você precisa cancelar o plano
                  VIP existente pelo painel antes de assinar um novo. Em caso de dúvida, entre em contato com nosso
                  suporte.
                  <router-link to="/subscriptions" class="text-white underline"
                    >Clique aqui para ver a lista de planos VIP ativos.
                  </router-link>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>

      <tab-content icon="feather icon-credit-card" class="mb-5">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vx-card>
              <OneTimePayment
                :paymentMethod="paymentMethod"
                :basket="basket"
                :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                :numberOfNonSubscriptionProducts="numberOfNonSubscriptionProducts"
              />
              <SubscriptionPayment
                :paymentMethod="paymentMethod"
                :basket="basket"
                :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                :numberOfNonSubscriptionProducts="numberOfNonSubscriptionProducts"
              />
            </vx-card>
          </div>

          <div class="vx-col w-full mt-6">
            <vx-card>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div
                    class="font-extrabold text-lg font-black w-full flex justify-end mb-6"
                    v-if="basket.discount > 0"
                  >
                    <h2>Subtotal: {{ basket.subtotal | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="font-extrabold text-lg w-full flex justify-end mb-6" v-if="basket.discount > 0">
                    <h2 class="text-success">Desconto: -{{ basket.discount | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="font-extrabold text-lg font-black w-full flex justify-end mb-6">
                    <h2>Total: {{ basket.total | money(basket.currency_code) }}</h2>
                  </div>
                  <div class="w-full flex mt-6">
                    <vs-button
                      type="relief"
                      color="danger"
                      class="w-1/2 mr-2"
                      @click="$refs.checkoutWizard.prevTab()"
                      :disabled="basket.processing"
                      >Voltar
                    </vs-button>
                    <vs-button
                      type="relief"
                      class="w-1/2 ml-2"
                      @click="lastStep()"
                      :disabled="basket.processing || !paymentMethod"
                    >
                      Continuar
                    </vs-button>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>

      <tab-content icon="feather icon-dollar-sign" class="mb-5">
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card class="mb-base">
              <div v-show="paymentMethod === 'card-stripe'">
                <CreditCardStripe
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></CreditCardStripe>
              </div>

              <div v-show="paymentMethod === 'card'">
                <CreditCardPayPal
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></CreditCardPayPal>
              </div>

              <div v-show="paymentMethod === 'paypal-order'">
                <PayPal
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></PayPal>
              </div>

              <div v-show="paymentMethod === 'stripe-subscription'">
                <StripeSubscription
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></StripeSubscription>
              </div>

              <div v-show="paymentMethod === 'card-pagarme' || paymentMethod === 'pagarme-subscription'">
                <Pagarme
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                  v-if="$refs.checkoutWizard"
                ></Pagarme>
              </div>

              <div v-show="paymentMethod === 'card-pagseguro' || paymentMethod === 'pagseguro-subscription'">
                <PagSeguro
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                  v-if="$refs.checkoutWizard"
                ></PagSeguro>
              </div>

              <div v-show="paymentMethod === 'card-mercadopago' || paymentMethod === 'mercadopago-subscription'">
                <MercadoPago
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                  v-if="$refs.checkoutWizard"
                ></MercadoPago>
              </div>

              <div v-show="paymentMethod === 'card-iugu' || paymentMethod === 'iugu-subscription'">
                <Iugu
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                  v-if="$refs.checkoutWizard"
                ></Iugu>
              </div>
              <div v-show="paymentMethod === 'card-galaxpay' || paymentMethod === 'galaxpay-subscription'">
                <GalaxPay
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  :numberOfSubscriptionProducts="numberOfSubscriptionProducts"
                  v-if="$refs.checkoutWizard"
                ></GalaxPay>
              </div>
              <div v-show="paymentMethod === 'paypal-subscription'">
                <PayPalSubscription
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></PayPalSubscription>
              </div>

              <div v-show="paymentMethod === 'boleto'">
                <Ticket
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></Ticket>
              </div>

              <div v-show="paymentMethod === 'transferencia'">
                <BankTransfer
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></BankTransfer>
              </div>

              <div v-show="paymentMethod === 'pix'">
                <Pix
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></Pix>
              </div>

              <div v-show="paymentMethod === 'picpay'">
                <PicPay
                  :basket="basket"
                  :paymentMethod="paymentMethod"
                  :checkoutWizard="$refs.checkoutWizard"
                  v-if="$refs.checkoutWizard"
                ></PicPay>
              </div>
            </vx-card>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card title="Detalhes da Compra">
              <div class="flex justify-between mb-2" v-if="basket.discount > 0">
                <span>Subtotal</span>
                <span class="font-semibold">{{ basket.subtotal | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="basket.discount > 0">
                <span class="text-success">Desconto</span>
                <span class="font-semibold text-success">-{{ basket.discount | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span>Pagamento Único</span>
                <span class="font-semibold">{{ basket.total | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="basket.subtotalRecurring > 0">
                <span>Pagamento Mensal</span>
                <span class="font-semibold text-success">{{
                  basket.subtotalRecurring | money(basket.currency_code)
                }}</span>
              </div>

              <vs-divider />
              <div class="flex justify-between">
                <span>Total Hoje</span>
                <span class="font-semibold">{{ basket.total | money(basket.currency_code) }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="basket.subtotalRecurring > 0">
                <span>Total Mensal</span>
                <span class="font-semibold text-success">{{
                  basket.subtotalRecurring | money(basket.currency_code)
                }}</span>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

const ItemListView = () => import('./components/ItemListView.vue');
const OneTimePayment = () => import('./components/OneTimePayment.vue');
const SubscriptionPayment = () => import('./components/SubscriptionPayment.vue');
const OrderDetails = () => import('./components/OrderDetails.vue');

const BankTransfer = () => import('./components/gateways/BankTransfer.vue');
const CreditCardPayPal = () => import('./components/gateways/CreditCardPayPal.vue');
const CreditCardStripe = () => import('./components/gateways/CreditCardStripe.vue');
const Ticket = () => import('./components/gateways/Ticket.vue');
const PayPal = () => import('./components/gateways/PayPal.vue');
const PayPalSubscription = () => import('./components/gateways/PayPalSubscription.vue');
const Pagarme = () => import('./components/gateways/Pagarme');
const PagSeguro = () => import('./components/gateways/PagSeguro');
const MercadoPago = () => import('./components/gateways/MercadoPago');
const Iugu = () => import('./components/gateways/CreditCardIugu');
const GalaxPay = () => import('./components/gateways/CreditCardGalaxPay');
const StripeSubscription = () => import('./components/gateways/StripeSubscription.vue');
const Pix = () => import('./components/gateways/Pix.vue');
const PicPay = () => import('./components/gateways/PicPay.vue');

export default {
  components: {
    Pagarme,
    PagSeguro,
    MercadoPago,
    OrderDetails,
    ItemListView,
    CreditCardPayPal,
    CreditCardStripe,
    Ticket,
    BankTransfer,
    Pix,
    PicPay,
    PayPal,
    FormWizard,
    TabContent,
    PayPalSubscription,
    StripeSubscription,
    OneTimePayment,
    SubscriptionPayment,
    Iugu,
    GalaxPay
  },
  data() {
    return {
      appFilename: process.env.VUE_APP_FILENAME,
      emailNewAccount: '',
      emailLogin: '',
      passwordNewAccount: '',
      termsConfirmation: false,
      passwordConfirmationNewAccount: '',
      password: '',
      affiliate: '',

      plans: [],
      planSelected: '',
      productId: null,
      planId: null,
      ip: null,
      card: '',

      isExpanded: false,
      funcoesAdicionais: ['Teclas Digitadas', 'Sites/Pesquisas', 'Foto Remota', 'Contatos'],

      orderDetails: {
        order: {},
        pix: {}
      },
      orderId: null,
      orderNumber: null,

      orderDetailsChecking: false,

      showCoupon: false,

      paymentMethod: '',
      basket: {
        firstname: '',
        lastname: '',
        name: '',
        email: '',
        telephone_country_code: '',
        telephone: '',
        coupon: {
          amount: 0
        },
        cpfcnpj: '',
        processing: false,
        plans: [],
        has_subscription: false,
        device_has_subscription: false,
        address_street: '',
        address_number: '',
        address_complement: '',
        address_city: '',
        address_state: '',
        address_postcode: '',
        address_country: 'br',
        subtotal: 0,
        subtotalRecurring: 0,
        discount: 0,
        total: 0,
        device: null,
        key: null,
        currency_code: 'BRL',
        locale: 'pt-BR'
      }
    };
  },
  mounted() {
    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff);
    }

    let language = window.navigator.userLanguage || window.navigator.language;
    if (language.indexOf('-') > -1) {
      language = language.split('-')[0];
    }

    this.$i18n.locale = 'pt';
    switch (language) {
      case 'pt':
      case 'en':
        this.$i18n.locale = language;
        break;
    }

    this.basket.locale = 'pt-BR';
    switch (language) {
      case 'en':
        this.basket.locale = 'en-GB';
        break;
    }

    this.basket.processing = true;

    this.planId = this.getParameterByName('planId');
    this.productId = this.getParameterByName('productId');
    this.orderId = this.getParameterByName('orderId');
    this.orderNumber = this.getParameterByName('orderNumber');
    this.ip = this.getParameterByName('ip');
    this.card = this.getParameterByName('card');

    this.basket.device = this.getParameterByName('d') ? atob(this.getParameterByName('d')) : null;
    this.basket.key = this.getParameterByName('k');

    const token = this.$localStorage.get('token');
    if (token && !this.planId && !this.productId && !this.orderId && !this.orderNumber && !this.card) {
      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data
          .filter(i => {
            return i.product_id == 1;
          })
          .reverse();
      });

      this.checkTokenWitouthPlanId();
    } else if (token && !this.planId && this.productId && !this.orderId && !this.orderNumber && !this.card) {
      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data
          .filter(i => {
            return i.product_id == this.productId;
          })
          .reverse();
      });

      this.checkTokenWitouthPlanId();
    } else if (token && this.planId && !this.productId && !this.orderId && !this.orderNumber && !this.card) {
      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data
          .filter(i => {
            return i.product_id == 1;
          })
          .reverse();
      });

      this.checkToken2();
    } else if (token && this.planId && this.productId && !this.orderId && !this.orderNumber && !this.card) {
      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data.filter(i => {
          return i.product_id == this.productId;
        });
      });

      this.checkToken();
      this.nextTab();
    } else if (token && this.orderId && this.orderNumber) {
      this.loadOrder();
    } else if (token && this.card && this.planId) {
      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data
          .filter(i => {
            return i.product_id == 1;
          })
          .reverse();
      });

      this.checkToken3();
    } else if (window.location.href.indexOf('/complete') > -1) {
      this.loadOrder();
    } else {
      this.basket.processing = false;
    }

    this.$EventBus.$on('changePaymentMethod', paymentMethod => {
      this.paymentMethod = paymentMethod;

      this.nextTab();
    });
  },
  beforeDestroy() {
    clearInterval(this.orderDetailsChecking);
  },
  computed: {
    numberOfNonSubscriptionProducts: function() {
      return this.basket.plans.filter(plan => plan.recurring == false).length;
    },
    numberOfSubscriptionProducts: function() {
      return this.basket.plans.filter(plan => plan.recurring == true).length;
    }
  },
  watch: {
    'basket.processing': function() {
      if (this.basket.processing) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded; // Alterna a visibilidade
    },

    signup() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/auth/register', {
          email: this.emailNewAccount,
          password: this.passwordNewAccount,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          this.$vs.notify({
            time: 6000,
            text: 'Sua conta foi criada com sucesso.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          });

          this.basket.firstname = response.data.firstname;
          this.basket.lastname = response.data.lastname;
          this.basket.name = response.data.name;
          this.basket.email = response.data.email;
          this.basket.cpfcnpj = response.data.cpfcnpj;
          this.basket.address_street = response.data.address_street;
          this.basket.address_number = response.data.address_number;
          this.basket.address_complement = response.data.address_complement;
          this.basket.address_city = response.data.address_city;
          this.basket.address_state = response.data.address_state;
          this.basket.address_postcode = response.data.address_postcode;
          this.basket.address_country = response.data.address_country || 'br';
          this.basket.telephone_country_code = response.data.telephone_country_code || 55;
          this.basket.telephone = response.data.telephone;

          // this.addPlan(this.planId);

          this.$localStorage.set('token', response.data.access_token);
          this.$localStorage.set('user', JSON.stringify(response.data));
          // this.$EventBus.$emit('userChanged');

          this.$api
            .get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : ''))
            .then(response => {
              this.plans = response.data.data.filter(i => {
                return i.product_id == 1;
              });
            });

          if (this.planId) {
            this.checkToken2();
          } else {
            this.checkTokenWitouthPlanId();
          }
        })
        .catch(error => {
          this.basket.processing = false;

          const data = error.response && error.response.data ? error.response.data : {};
          const message = Array.isArray(data.errors)
            ? data.errors.join('<br>')
            : data.error || data.message || 'Não foi possível criar a conta. Tente novamente.';

          this.$vs.notify({
            time: 6000,
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },

    redirectPlan() {
      window.location.href = 'https://lite-beta.vercel.app/';
    },

    continueCheckoutPlan() {
      this.planId = this.planSelected;
      this.addPlan(this.planId);
      this.$EventBus.$emit('userChanged');

      this.checkToken();
      // this.lastStep();
    },

    checkTokenWitouthPlanId() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          // this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
            this.basket.processing = false;
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },

    checkToken() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    checkToken2() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            return this.addPlan(this.planId).then(() => {
              if (this.basket.plans.length > 0) {
                this.nextTab();
                this.nextTab();
              }
            });
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    checkToken3() {
      this.$api
        .post('/api/v1/auth/me')
        .then(response => {
          this.addPlan(this.planId);

          this.$EventBus.$emit('userChanged');

          if (response.data.email) {
            this.basket.firstname = response.data.firstname;
            this.basket.lastname = response.data.lastname;
            this.basket.name = response.data.name;
            this.basket.email = response.data.email;
            this.basket.cpfcnpj = response.data.cpfcnpj;
            this.basket.address_street = response.data.address_street;
            this.basket.address_number = response.data.address_number;
            this.basket.address_complement = response.data.address_complement;
            this.basket.address_city = response.data.address_city;
            this.basket.address_state = response.data.address_state;
            this.basket.address_postcode = response.data.address_postcode;
            this.basket.address_country = response.data.address_country || 'br';
            this.basket.telephone_country_code = response.data.telephone_country_code || 55;
            this.basket.telephone = response.data.telephone;

            this.nextTab();
            this.nextTab();
            this.nextTab();
            this.$EventBus.$emit('changePaymentMethod', this.card);
          }
        })
        .catch(() => {
          this.basket.processing = false;
          this.$localStorage.set('token', '');
          this.$localStorage.set('user', '');
        });
    },
    nextTab() {
      if (this.$refs.checkoutWizard) {
        this.$refs.checkoutWizard.nextTab();
      }
    },
    login() {
      if (this.productId && !this.planId) {
        this.$router.push('/pages/login?returnTo=/checkout/payment?productId=' + this.productId);
      } else if (this.planId && !this.productId) {
        this.$router.push('/pages/login?returnTo=/checkout/payment?planId=' + this.planId);
      } else {
        this.$router.push('/pages/login?returnTo=/checkout/payment');
      }
    },
    logout() {
      this.basket.processing = false;
      this.$localStorage.set('token', '');
      this.$localStorage.set('user', '');

      this.basket.firstname = '';
      this.basket.lastname = '';
      this.basket.name = '';
      this.basket.email = '';
      this.basket.cpfcnpj = '';
      this.basket.address_street = '';
      this.basket.address_number = '';
      this.basket.address_complement = '';
      this.basket.address_city = '';
      this.basket.address_state = '';
      this.basket.address_postcode = '';
      this.basket.address_country = 'br';
      this.basket.telephone_country_code = '';
      this.basket.telephone = '';
    },
    addPlan(planId) {
      this.basket.processing = true;

      planId = parseInt(planId) > 0 ? planId : 0;
      return this.$api
        .get('/api/v1/checkout/plan/add/' + planId + '?ip=' + this.ip, {
          params: {
            k: this.basket.key
          }
        })
        .then(response => {
          this.basket.processing = false;

          this.basket.currency_code = response.data.currency_code;
          this.basket.plans = response.data.plans;
          this.basket.has_subscription = response.data.has_subscription;
          this.basket.device_has_subscription = response.data.device_has_subscription;
          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          if (response.data.total > 0) {
            this.$gtm.trackEvent({
              event: 'conversion',
              send_to: 'AW-604564883/slchCJbyz4YCEJPbo6AC',
              totalCarrinho: parseFloat(this.basket.total),
              currency: this.basket.currency_code,
              value: parseFloat(this.basket.total),
              transaction_id: ''
            });
          }

          if (response.data.message) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          } else if (this.basket.plans.length === 0) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Não foi possível adicionar plano ao carrinho.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });

            this.$localStorage.set('token', '');
            this.$localStorage.set('user', '');
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    removePlan(item) {
      this.basket.processing = true;

      this.$api
        .get('/api/v1/checkout/plan/' + item.id + '/remove')
        .then(response => {
          this.basket.plans = response.data.plans;

          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          if (this.basket.plans.length === 0) {
            window.location.reload();
          } else {
            this.basket.processing = false;
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    applyCoupon() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/total?ip=' + this.ip, {
          basket: this.basket
        })
        .then(response => {
          this.basket.processing = false;

          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          if (!response.data.discount) {
            this.$vs.notify({
              time: 6000,
              title: 'Aviso',
              text: 'Cupom Inválido',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    loadOrder() {
      this.$api
        .get('/api/v1/checkout/order/' + (this.orderId || 0) + '/' + (this.orderNumber || 0) + '?ip=' + this.ip)
        .then(response => {
          this.basket.processing = false;
          this.orderDetails = response.data;
          this.orderId = response.data.order.id;
          this.orderNumber = response.data.order.number;

          this.$gtm.trackEvent({
            event: 'conversion',
            send_to: 'AW-604564883/ZHxjCLTYiOsBEJPbo6AC',
            numeroVenda: this.orderDetails.order.number,
            totalVenda: parseFloat(this.orderDetails.order.total),
            currency: this.basket.currency_code,
            value: parseFloat(this.orderDetails.order.total),
            transaction_id: this.orderDetails.order.number
          });

          if (response.data.order.status === 'Aguardando Pagamento') {
            clearInterval(this.orderDetailsChecking);
            this.orderDetailsChecking = setInterval(() => this.loadOrder(), 5000);
          } else {
            clearInterval(this.orderDetailsChecking);
          }
        })
        .catch(error => {
          this.basket.processing = false;

          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    updateItemQuantity(item) {
      this.basket.processing = true;

      if (parseInt(item.quantity) === 0 || isNaN(item.quantity) || isNaN(parseInt(item.quantity))) {
        item.quantity = 1;
      }

      this.$api
        .post(`/api/v1/checkout/plan/${item.id}/quantity/${item.quantity}` + '?ip=' + this.ip)
        .then(response => {
          this.basket.processing = false;
          this.basket.plans = response.data.plans;

          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;
          console.log(this.basket, response.data);
        })
        .catch(error => {
          this.basket.processing = false;
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },
    lastStep() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/total?ip=' + this.ip, {
          basket: this.basket
        })
        .then(response => {
          this.basket.processing = false;

          this.basket.subtotal = response.data.subtotal;
          this.basket.subtotalRecurring = response.data.subtotalRecurring;
          this.basket.discount = response.data.discount;
          this.basket.total = response.data.total;

          this.nextTab();
        });
    },
    changePlanSelected(plan) {
      console.log(plan);
      this.planSelected = plan;
    }
  }
};
</script>

<style lang="scss" scoped>
#ecommerce-checkout {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .rotated {
    transform: rotate(180deg); /* Rotaciona a imagem 90 graus */
    transition: transform 0.3s ease; /* Adiciona uma transição suave */
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
